module.exports = __webpack_public_path__ + "img/plus-package.ec0fc972.svg";